import { createContext } from 'react'

export const AccordionContext = createContext<{
    expandedItemId: string | null
    toggleAccordion: ((id: string) => void) | null
}>({
    expandedItemId: null,
    toggleAccordion: null,
})
